import { INavigationItem } from 'modules/stroyblok/types';

export const parseItems = (navigationItem: INavigationItem) => {
  const { flyoutColumns, children } = navigationItem;
  if (flyoutColumns?.length) {
    return flyoutColumns.flatMap((column) => column.items || []) || [];
  }

  return children || [];
};
